import { combineReducers } from 'redux';

import pickUp from './endpoints/pickUp';
import forecastByDay from './endpoints/forecastByDay';
import forecastByMonth from './endpoints/forecastByMonth';
import budgetByDay from './endpoints/budgetByDay';
import budgetByMonth from './endpoints/budgetByMonth';
import businessAnalysis from './endpoints/businessAnalysis';
import businessAnalysisByRoomType from './endpoints/businessAnalysisByRoomType';
import overnightStats from './endpoints/overnightStats';
import currentRoomsRevenueByDay from './endpoints/currentRoomsRevenueByDay';
import lyFinalRoomsRevenueByDay from './endpoints/lyFinalRoomsRevenueByDay';
import lySpitRoomsRevenueByDay from './endpoints/lySpitRoomsRevenueByDay';
import lySpitRoomsRevenueByMonth from './endpoints/lySpitRoomsRevenueByMonth';
import y2FinalRoomsRevenueByDay from './endpoints/y2FinalRoomsRevenueByDay';
import y2SpitRoomsRevenueByDay from './endpoints/y2SpitRoomsRevenueByDay';
import statisticsByDay from './endpoints/statisticsByDay';
import commissionByPeriod from './endpoints/commissionByPeriod';
import lyFinalCommissionByPeriod from './endpoints/lyFinalCommissionByPeriod';
import lySpitCommissionByPeriod from './endpoints/lySpitCommissionByPeriod';
import businessChangeByMonth from './endpoints/businessChangeByMonth';
import businessChangeByDay from './endpoints/businessChangeByDay';
import recommendationRevenueGain from './endpoints/recommendationRevenueGain';
import inventoryBlocks from './endpoints/inventoryBlocks';
import cancellationReportTransientBusiness from './endpoints/cancellationReportTransientBusiness';
import bookings from './endpoints/bookings';
import vendorOauth from './endpoints/vendorOauth';
import fiscalPeriods from './endpoints/fiscalPeriods';
import recommendationsCountByMonth from './endpoints/recommendationsCountByMonth';
import roomRecommendationsCountByMonth from './endpoints/roomRecommendationsCountByMonth';
import roomRecommendationsCountByDay from './endpoints/roomRecommendationsCountByDay';
import adminPropertyList from './endpoints/adminPropertyList';
import adminFeatureList from './endpoints/adminFeatureList';
import deletePropertyCache from './endpoints/adminDeletePropertyCache';
import roomTypes from './endpoints/roomTypes';
import sellingRate from './endpoints/sellingRate';
import hurdleRackRates from './endpoints/hurdleRackRates';
import inventoryBlocksMonthly from './endpoints/inventoryBlocksMonthly';
import otaInsightsDailyWithChange from './endpoints/otaInsightsDailyWithChange';

const dataGlobalReducer = combineReducers({
    [pickUp.KEY]: pickUp.reducer,
    [forecastByDay.KEY]: forecastByDay.reducer,
    [forecastByMonth.KEY]: forecastByMonth.reducer,
    [budgetByDay.KEY]: budgetByDay.reducer,
    [budgetByMonth.KEY]: budgetByMonth.reducer,
    [businessAnalysis.KEY]: businessAnalysis.reducer,
    [businessAnalysisByRoomType.KEY]: businessAnalysisByRoomType.reducer,
    [overnightStats.KEY]: overnightStats.reducer,
    [currentRoomsRevenueByDay.KEY]: currentRoomsRevenueByDay.reducer,
    [lyFinalRoomsRevenueByDay.KEY]: lyFinalRoomsRevenueByDay.reducer,
    [lySpitRoomsRevenueByDay.KEY]: lySpitRoomsRevenueByDay.reducer,
    [lySpitRoomsRevenueByMonth.KEY]: lySpitRoomsRevenueByMonth.reducer,
    [y2FinalRoomsRevenueByDay.KEY]: y2FinalRoomsRevenueByDay.reducer,
    [y2SpitRoomsRevenueByDay.KEY]: y2SpitRoomsRevenueByDay.reducer,
    [statisticsByDay.KEY]: statisticsByDay.reducer,
    [commissionByPeriod.KEY]: commissionByPeriod.reducer,
    [lyFinalCommissionByPeriod.KEY]: lyFinalCommissionByPeriod.reducer,
    [lySpitCommissionByPeriod.KEY]: lySpitCommissionByPeriod.reducer,
    [businessChangeByMonth.KEY]: businessChangeByMonth.reducer,
    [businessChangeByDay.KEY]: businessChangeByDay.reducer,
    [recommendationRevenueGain.KEY]: recommendationRevenueGain.reducer,
    [inventoryBlocks.KEY]: inventoryBlocks.reducer,
    [cancellationReportTransientBusiness.KEY]: cancellationReportTransientBusiness.reducer,
    [bookings.KEY]: bookings.reducer,
    [vendorOauth.KEY]: vendorOauth.reducer,
    [fiscalPeriods.KEY]: fiscalPeriods.reducer,
    [recommendationsCountByMonth.KEY]: recommendationsCountByMonth.reducer,
    [roomRecommendationsCountByMonth.KEY]: roomRecommendationsCountByMonth.reducer,
    [roomRecommendationsCountByDay.KEY]: roomRecommendationsCountByDay.reducer,
    [adminPropertyList.KEY]: adminPropertyList.reducer,
    [adminFeatureList.KEY]: adminFeatureList.reducer,
    [deletePropertyCache.KEY]: deletePropertyCache.reducer,
    [roomTypes.KEY]: roomTypes.reducer,
    [sellingRate.KEY]: sellingRate.reducer,
    [hurdleRackRates.KEY]: hurdleRackRates.reducer,
    [inventoryBlocksMonthly.KEY]: inventoryBlocksMonthly.reducer,
    [otaInsightsDailyWithChange.KEY]: otaInsightsDailyWithChange.reducer,
});

export default dataGlobalReducer;
